import React, { Component } from 'react';

import renderHTML from 'react-render-html';
import PropTypes from 'prop-types';

import { AddFavorite, StorageHandler } from 'C4';
import { storageKeys } from 'settings';

const SpotifyPlayer = (props) => {
  const { links, width } = props;
  const parsedElements = [];

  links.forEach((link, i) => {
    const key = `${link}_${i}`;
    if (link.url.length > 0 && link.url.includes('spotify')) {
      parsedElements.push(<iframe
        key={key}
        title={link.url}
        src={link.url}
        height="500px"
        width={width}
      />);
    }
  });

  return parsedElements;
};

export default class TrainingText extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: '',
    };
  }

  componentDidMount() {
    const { appId, pageType, upID } = this.props;
    let { text } = this.props;
    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = '';
      ({ email } = userObj);
      this.setState({ text });

      // const weblinks = text.getElementsByTagName('a');
      // for (let i = 0, len = weblinks.length; i < len; i++) {
      //   weblinks[i].target = '_blank';
      // }
    });

    this.props.contentComplete();
  }

  render() {
    const {
      appId,
      buttons,
      links,
      pageID,
      pageType,
      subtitle,
      title,
      type,
      upID,
      hideTitle,
    } = this.props;

    const { text } = this.state;

    return (
      <div
        className={`text__container ${pageType === 'Final-Page' ? 'wideFinalPage' : undefined}`}
        key={upID}
      >
        {/* <div className="text__container" key={upID}> */}
        {buttons}
        {((pageType === 'Final-Page') || (pageType === 'Introduction')) &&
          <div className="image" />
        }
        {!hideTitle && <h3 className={`pageTitle ${pageType === 'Final-Page' && 'finalPageTitle'}`}>{title}</h3>}
        <h4>{subtitle}</h4>
        {type === 'Spotify' && (
          <SpotifyPlayer
            links={links}
            width="100%"
          />
        )}
        <div className="bodyContent">
          {renderHTML((
            text
              .replace(/&lt;/g, '<')
              .replace(/&gt;/g, '>')
              .replace(/allowTransparency="[a-zA-Z0-9:;.s()\-,]*"/gi, '')
              .replace(/allowfullscreen/gi, 'allowFullScreen="allowFullScreen"')
            ))
          }
        </div>
        {pageType !== 'Final-Page' &&
        <AddFavorite
          appId={appId}
          viewType="p"
          upID={upID}
          pageID={pageID}
          bgEnabled
          centered
        />}
      </div>
    );
  }
}

TrainingText.propTypes = {
  buttons: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.element,
  ]),
  appId: PropTypes.number.isRequired,
  contentComplete: PropTypes.func,
  hideTitle: PropTypes.bool,
  links: PropTypes.arrayOf(PropTypes.object),
  pageID: PropTypes.string,
  pageType: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  text: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
  upID: PropTypes.string.isRequired,
};

TrainingText.defaultProps = {
  buttons: [],
  contentComplete: () => {},
  hideTitle: false,
  links: [],
  pageID: '',
  subtitle: '',
  text: '',
  title: '',
  type: '',
};
